import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'

const Helpdesk = () => {
  return (
    <Box>
      <Outlet />
    </Box>
  )
}

export default Helpdesk
